<!-- 点赞 -->
<template>
  <div id="" class="giveLike" @click="handleClick">
    <div class="circle flex-h" :class="isUp ? 'check' : ''">
      <div class="img-box" :class="isUp ? 'img-box-check' : ''">
        <i
          v-if="isUp"
          class="iconfont icon-zan1 font"
          style="color: #ff5f53"
        ></i>
        <i v-else class="iconfont icon-zan font" style="color: #424242"></i>
      </div>
    </div>
    <div :class="[isUp ? 'active' : 'noActive', 'font']">
      {{ mygiveLike.praised_count }}
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  components: {},
  props: {
    mygiveLike: {
      type: Object,
      default: () => {
        return {
          // 当前点赞
          praised_count: 1,
          // 当前评论ID
          reamrk_id: 1,
          // 是否以及点赞
          is_praised: 0,
          time: "1999.99.99（缺少时间）",
          username: "测试",
        };
      },
    },
    // 当前分享ID
    share_id: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      // isUp: this.myisUp
    };
  },
  created() {},
  mounted() {},
  computed: {
    ...mapState(["token", "agency_id"]),
    isUp() {
      if (this.mygiveLike.is_praised == 0) {
        return false;
      } else {
        return true;
      }
    },
  },
  watch: {
    // 如果is_praised的值不等于0 则代表用户以及点过赞了
    // mygiveLike(newValue) {
    //   console.log("值变化了")
    //   console.log(newValue)
    //   if (newValue != 0) {
    //     this.isUp = true;
    //   }
    // },
  },
  methods: {
    // 点赞操作
    handleClick() {
      if (this.isUp) {
        this.$message({
          message: "只能点赞一次噢~",
          type: "warning",
        });
        return;
      }
      this.$axios
        .get("/givePraised", {
          params: {
            token: this.token,
            agency_id: this.agency_id,
            share_id: this.share_id,
            remark_id: this.mygiveLike.reamrk_id,
          },
        })
        .then((doc) => {
          if (doc == null) {
            this.mygiveLike.is_praised = true;
            this.mygiveLike.praised_count++;
            this.$message({
              message: "点赞成功",
              type: "success",
            });
          } else {
            this.$message(doc.data.message);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>

<style lang='less' scoped>
.giveLike {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  .active {
    font-size: 0.75rem;
    font-family: "Microsoft YaHei";
    font-weight: 400;
    color: #ff5f53;
  }
  .noActive {
    font-size: 0.75rem;
    font-family: " Microsoft YaHei";
    font-weight: 400;
    color: #424242;
  }
  .circle {
    display: flex;
    align-items: center;
    width: 1.5625rem;
    height: 1.5625rem;
    border-radius: 50%;
    box-shadow: 0px 0px 0px 0px rgba(255, 105, 105, 0.5);
    .img-box {
      width: 1.25rem;
      height: 1.25rem;
      margin: 0.3125rem;
      -moz-user-select: none;
      -webkit-user-select: none;
      -ms-user-select: none;
      -khtml-user-select: none;
      user-select: none; // 防止快速点击图片被选中，可不加，为提高体验，博主加上了这几行代码。
      & img {
        width: 100%;
        height: 100%;
      }
    }
  }
  .check {
    -webkit-transition: box-shadow 0.5s;
    -moz-transition: box-shadow 0.5s;
    -o-transition: box-shadow 0.5s;
    transition: box-shadow 0.5s;
    box-shadow: 0px 0px 0px 1em rgba(255, 105, 105, 0);
  }
  .img-box-check {
    animation: anm 0.5s;
    -moz-animation: anm 0.5s;
    -webkit-animation: anm 0.5s;
    -o-animation: anm 0.5s;
  }
}
@keyframes anm {
  0% {
    transform: scale(0);
    -webkit-transform: scale(0);
    -moz-transform: scale(0);
  }
  50% {
    transform: scale(1.3);
    -webkit-transform: scale(1.3);
    -moz-transform: scale(1.3);
  }
  100% {
    transform: scale(1);
    -webkit-transform: scale(1);
    -moz-transform: scale(1);
  }
}

// 以下为处理兼容代码，可不看。

@-moz-keyframes anm {
  0% {
    transform: scale(0);
    -webkit-transform: scale(0);
    -moz-transform: scale(0);
  }
  50% {
    transform: scale(1.3);
    -webkit-transform: scale(1.3);
    -moz-transform: scale(1.3);
  }
  100% {
    transform: scale(1);
    -webkit-transform: scale(1);
    -moz-transform: scale(1);
  }
}

@-webkit-keyframes anm {
  0% {
    transform: scale(0);
    -webkit-transform: scale(0);
    -moz-transform: scale(0);
  }
  50% {
    transform: scale(1.3);
    -webkit-transform: scale(1.3);
    -moz-transform: scale(1.3);
  }
  100% {
    transform: scale(1);
    -webkit-transform: scale(1);
    -moz-transform: scale(1);
  }
}

@-o-keyframes anm {
  0% {
    transform: scale(0);
    -webkit-transform: scale(0);
    -moz-transform: scale(0);
  }
  50% {
    transform: scale(1.3);
    -webkit-transform: scale(1.3);
    -moz-transform: scale(1.3);
  }
  100% {
    transform: scale(1);
    -webkit-transform: scale(1);
    -moz-transform: scale(1);
  }
}
</style>